<script lang="ts" setup>
import { computed } from 'vue'
import type { AsyncDataResponse, Props } from './types'
import RecommendationsCarousel from '@/components/RecommendationsCarousel/index.vue'

const { $sobreplanosDataService } = useNuxtApp()

const props = defineProps<Props>()

const { data: recommendedListingsResponse, error } = await useAsyncData<AsyncDataResponse>('recommendations', () => $sobreplanosDataService.getListings({
  filters: {
    business_hub: props.businessHub
  },
  refresh: props.refresh
}))

const logger = useLogger()

if (error.value) {
  logger.error({
    message: error.value.message,
    stack: error.value
  })
}

const recommendedListings = computed(() => {
  if (error.value) return []

  return recommendedListingsResponse.value.results
})
</script>

<script lang="ts">
export default {
  name: 'PdRecommendations'
}
</script>

<template>
  <RecommendationsCarousel
    v-if="recommendedListings.length"
    :listing-id="props.projectCode"
    :business-hubs="props.businessHub"
    :projects="recommendedListings" />
</template>
